import { AbstractPmsApiService } from "./abstract.service";
import { GuestsList } from "../models";

/**
 * @class GuestsListPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<GuestsList>}
 */
export class GuestsListPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/guests-list(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {GuestsList}
     * @protected
     */
    newModel(attributes, ...params) {

        return new GuestsList(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<GuestsList>>}
     */
    get (params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsList} list
     * @param {Property} property
     * @returns {Promise.<GuestsList>}
     */
    create(list, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, list.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsList} list
     * @returns {Promise.<GuestsList>}
     */
    update(list) {

        const url = this.url({
            propertyId: list.property.id,
            id:         list.id
        });

        return this.http
            .put(url, list.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {GuestsList} list
     * @returns {Promise.<boolean>}
     */
    delete(list) {

        const url = this.url({
            propertyId: list.property.id,
            id:         list.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/guests-list.service.js